import type { StatusSeverity } from 'components/_base/StatusChip'

export const DATA_CHANGE_REQUEST_TYPES = [
  { value: 'lead', label: 'Company Data' },
  { value: 'isp', label: 'ISP' },
] as const

export type DataChangeRequestType = (typeof DATA_CHANGE_REQUEST_TYPES)[number]['value']

// Never default to the mixed list: accepting an `isp` request flags the company as an internet provider for every customer.
export const INITIAL_DATA_CHANGE_REQUEST_FILTERS = {
  status: 'pending',
  type: 'lead' as DataChangeRequestType,
  search: '',
}

const REQUEST_TYPE: Record<string, { label: string; severity: StatusSeverity }> = {
  lead: { label: 'Company Data', severity: 'info' },
  isp: { label: 'ISP', severity: 'warning' },
}

export const requestType = (type?: string) =>
  REQUEST_TYPE[type || ''] ?? { label: type || 'Unknown', severity: 'default' as const }

// Pending is the default filter, so it stays quiet; the colour only carries meaning on the history views.
const REQUEST_STATUS: Record<string, { label: string; severity: StatusSeverity }> = {
  pending: { label: 'Pending', severity: 'default' },
  accepted: { label: 'Accepted', severity: 'success' },
  rejected: { label: 'Rejected', severity: 'error' },
}

export const requestStatus = (status?: string) =>
  REQUEST_STATUS[status || ''] ?? { label: status || 'Unknown', severity: 'default' as const }
